import { Divider, Typography, Paper, Box, CircularProgress } from '@mui/material'
import React from 'react'
import SelectInstitute from '../../components/admin/SelectInstitute'
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'
import api from '../../service/api'
import WcIcon from '@mui/icons-material/Wc'
import PeopleAltIcon from '@mui/icons-material/PeopleAlt'
import DeviceHubIcon from '@mui/icons-material/DeviceHub'
import DescriptionIcon from '@mui/icons-material/Description'
import AssignmentIcon from '@mui/icons-material/Assignment'
import MenuBookIcon from '@mui/icons-material/MenuBook'
import AnalyticsCountCard from '../../components/admin/AnalyticsCountCard'
import { observer } from 'mobx-react'
import { useEffect } from 'react'
import { useUserStore } from '../../store/user.store'
import warningImg from '../../assets/warning.svg'
import selectInstituteImg from '../../assets/selectinstitute.svg'

const COLORS = ['#E31A4B', '#F26922', '#F7B217', '#B6D433', '#209D48', '#3FBED5', '#745BA7', '#E31A4B', '#F26922']

const Analytics = observer( () => {
    const [instituteCode, setInstituteCode] = React.useState( '0' )
    const [isLoading, setIsLoading] = React.useState( false )
    const [facultyCount, setFacultyCount] = React.useState( 0 )
    const [studentCount, setStudentCount] = React.useState( 0 )
    const [branchCount, setBranchCount] = React.useState( 0 )
    const [branchUserCount, setBranchUserCount] = React.useState( [] )
    const [noteCount, setNoteCount] = React.useState( 0 )
    const [assignmentCount, setAssignmentCount] = React.useState( 0 )
    const [examCount, setExamCount] = React.useState( 0 )
    const [hasPermission, setHasPermission] = React.useState( true )

    const UserStore = useUserStore()

    const handleChange = async ( val ) => {
        setIsLoading( true )
        setInstituteCode( val )
        loadAllStat( val )
        setIsLoading( false )
    }

    const loadAllStat = async ( val ) => {
        setBranchUserCount( [] )
        try {
            const res = await api.getInstituteFacultyCount( val )
            setFacultyCount( res["data"]["count"] ? res["data"]["count"] : 0 )
        } catch ( err ) {
            console.log( err )
        }

        try {
            const res = await api.getInstituteStudentCount( val )
            setStudentCount( res["data"]["count"] ? res["data"]["count"] : 0 )
            // setBranchUserCount( [{ "branch": "ALL", "count": parseInt( facultyCount ) + parseInt( studentCount ) }] )
        } catch ( err ) {
            console.log( err )
        }

        try {
            const res = await api.getInstituteBranchCount( val )
            setBranchCount( res["data"]["count"] ? res["data"]["count"] : 0 )
        } catch ( err ) {
            console.log( err )
        }

        try {
            const res = await api.getInstituteStudyMaterialCount( val )
            console.log( res.data )
            setNoteCount( res["data"]["data"]["count"] ? res["data"]["data"]["count"] : 0 )
        } catch ( err ) {
            console.log( err )
        }

        try {
            const res = await api.getInstituteAssignmentCount( val )
            setAssignmentCount( res["data"]["count"] ? res["data"]["count"] : 0 )
        } catch ( err ) {
            console.log( err )
        }

        try {
            const res = await api.getInstituteExamCount( val )
            setExamCount( res?.data ? res?.data?.data : 0 )
        } catch ( err ) {
            console.log( err )
        }

        try {
            const res = await api.getInstituteBranchUserCount( val )
            console.log( res["data"]["data"] )
            setBranchUserCount( res["data"]["data"] ? res["data"]["data"] : [] )
        } catch ( err ) {
            console.log( err )
        }
    }

    useEffect( () => {
        if ( UserStore.getUser.user_role === 'subadmin' && !UserStore.getUser.user_permissions.analytics ) {
            setHasPermission( false )
        } else {
            loadAllStat( "AUZ" )
        }
    }, [UserStore] )

    return (
        <Box borderRadius="5px" padding={{ xs: "10px", md: "20px" }} overflow="auto">
            {hasPermission && <Box>
                <Paper >
                    <Typography sx={{ padding: "20px", paddingBottom: "0" }} variant='h5'>Dashboard</Typography>
                    <Typography sx={{ padding: "20px", paddingTop: "0" }} color="textSecondary" variant='subtitle2'>View all the data in one place</Typography>
                </Paper>
                {!isLoading && <Box marginTop="20px" display="grid" gridTemplateColumns={{ lg: "33% auto", xs: "1fr" }} gap="20px">
                    <Paper sx={{ padding: "20px", background: "#fff" }} >
                        <Box display="grid" gap="10px" gridTemplateColumns="1fr 1fr">
                            <Box>
                                <AnalyticsCountCard count={facultyCount} entity="Faculties" icon={<PeopleAltIcon />} />
                            </Box>
                            <Box>
                                <AnalyticsCountCard count={studentCount} entity="Students" icon={<WcIcon />} />
                            </Box>
                            <Box>
                                <AnalyticsCountCard count={branchCount} entity="Branches" icon={<DeviceHubIcon />} />
                            </Box>
                            <Box>
                                <AnalyticsCountCard count={noteCount} entity="Notes" icon={<DescriptionIcon />} />
                            </Box>
                            <Box>
                                <AnalyticsCountCard count={assignmentCount} entity="Assignments" icon={<AssignmentIcon />} />
                            </Box>
                            <Box>
                                <AnalyticsCountCard count={examCount} entity="Exams" icon={<MenuBookIcon />} />
                            </Box>
                        </Box>
                    </Paper>
                    <Box>
                        <Paper sx={{ flexGrow: 1, height: "100%" }} >
                            <Typography padding="20px 20px 10px 20px" variant="h6" component="h6" gutterBottom>
                                User(s) across all Branches AUZ
                            </Typography>
                            <Divider sx={{ marginBottom: "20px" }} />
                            {branchUserCount.length > 0 && <ResponsiveContainer height="70%" width="99%">
                                <BarChart
                                    data={branchUserCount}
                                    margin={{
                                        top: 5,
                                        right: 30,
                                        left: 20,
                                        bottom: 5,
                                    }}
                                >
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis fontSize="12px" dataKey="branch" angle={-90} dy={12} allowDataOverflow={false} />
                                    <YAxis fontSize="12px" />
                                    <Tooltip />
                                    {/* <Legend /> */}

                                    <Bar
                                        dataKey="count"
                                        strokeWidth={1}>
                                        {
                                            branchUserCount.map( ( entry, index ) => (
                                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                            ) )
                                        }
                                    </Bar>
                                </BarChart>
                            </ResponsiveContainer>}
                            {branchUserCount.length === 0 && <Box gap="20px" height="70%" display="flex" alignItems="center" justifyContent="center">
                                <CircularProgress size={30} />
                                <Typography color="textSecondary" variant='h6'>Loading {instituteCode} data...</Typography>
                            </Box>}
                        </Paper>
                    </Box>
                </Box>}
            </Box>}
            {!hasPermission && <Paper sx={{ display: "flex", justifyContent: "center", padding: "20px", gap: "20px", alignItems: "center" }}>
                <img src={warningImg} width="40px" alt="No permission" />
                <Typography variant='subtitle2' color="textSecondary">You doesn't have permission to access this page!</Typography>
            </Paper>}
        </Box>
    )
} )

export default Analytics
